<template>
    <div class="box">
        <div class="tabbar" v-if="tabbarShow" :class="navBarFixed ? 'navBarFixed' : ''">
            <img @click="goback" src="../../../../static/common/logo.png" alt="" />

        </div>
        <div class="contens">
            <div class="banner">

            </div>
            <div class="wapbanner">

            </div>


            <div id="login" ref="targetTops">

                <div class="login-flex">
                    <div class="interactive">
                        <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号"
                            @blur="changePhone" />
                        <div class="codeBox">
                            <input v-model="form.code" type="text" placeholder="请输入验证码" />
                            <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                            <span v-else>重新获取({{ verSecond }})</span>
                        </div>

                        <div class="buttom" @click="submit(form)">
                            <img src="/subject/anniversary/login.png" alt="">
                        </div>
                    </div>
                </div>

            </div>
            <div :class="navBarFixed ? 'waplogin logins' : isApp ? 'waplogin waplogin1' : 'waplogin'" ref="targetTops">

                <div class="login-flex">
                    <div class="interactive">
                        <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号"
                            @blur="changePhone" />
                        <div class="codeBox">
                            <input v-model="form.code" type="text" placeholder="请输入验证码" />
                            <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                            <span v-else>重新获取({{ verSecond }})</span>
                        </div>

                        <div class="buttom" @click="submit(form)">
                            <img src="/subject/anniversary/wap/login.png" alt="">
                        </div>
                    </div>
                </div>

            </div>

            <div class="content">
                <div class="part">
                    <div class="part1">

                        <img class="partbox" src="/subject/anniversary/cart.png" alt="">
                        <div class="rule" @click="showDialogs"></div>
                        <img class="button1" @click="tosCroll" src="/subject/anniversary/button2.png" alt="">
                        <img class="button" @click="live800" src="/subject/anniversary/button1.png" alt="">

                        <div class="part2 clearfix">

                            <img class="partbox" src="/subject/anniversary/cart1.png" alt="">


                        </div>

                    </div>



                    <div class="part3">
                        <img class="partbox" src="/subject/anniversary/cart2.png" alt="">

                        <img class="button" @click="tosCroll" src="/subject/anniversary/button.png" alt="">

                    </div>
                </div>
                <contactus-vue></contactus-vue>

            </div>
            <div class="wapcontent">
                <div class="part">
                    <div class="part1">

                        <img src="/subject/anniversary/wap/cart.png" alt="">
                        <div class="rule" @click="showDialogs">

                        </div>
                        <img class="button" @click="tosCroll" src="/subject/anniversary/wap/button2.png" alt="">
                        <img class="button1" @click="live800" src="/subject/anniversary/wap/button1.png" alt="">
                        <div class="part2 clearfix">

                            <img src="/subject/anniversary/wap/cart1.png" alt="">

                        </div>

                    </div>



                    <div class="part3">
                        <img src="/subject/anniversary/wap/cart2.png" alt="">
                        <img src="/subject/anniversary/wap/button.png" class="button" @click="tosCroll" alt="">


                    </div>
                </div>
            </div>
        </div>




        <!-- 活动规则 -->
        <div class="popup" v-if="controlPop">
            <span @click="closePop" class="closer1">X</span>
            <ul class="popContent">
                <li class="top-tit">
                    十五载星河同耀，首签臻享 588 元现金 超多豪礼接踵而至
                </li>

                <li>
                    <span>活动周期：</span>
                    即日起一{{ getLastDayOfMonth() }}

                </li>
                <li>
                    <span>第一阶段</span><br />
                    <span>注册秒领好礼</span><br />

                    1.人民币：用户注册成功后，立即可以领取人民币红包288 元，前往平台——我的钱包 中查看。<br />

                    2.美元赠金：注册即送588美元赠金，按照交易手数笔笔提取，前往平台——我的——赠金奖励 中查看。

                </li>
                <li>
                    <span>第二阶段</span><br />
                    <span>激活无限权益</span><br />

                    激活账户，根据24小时内入金层级不同获得300~900人民币不同额度的等额美元现金，详情参考下表，新客最超值推荐领取588元层级！想冲最大福利，直接选1188元层级，准没错！<br />

                    激活账户后，您的福利自动提取到交易账户进行交易使用，仅需在 7 天内完成对应手数交易，详情参考表格。完成后，该笔资金可提取可交易，无限制。​<br />

                    同时，享有入金即送等额美元赠金福利，仅限新户，充值越多，赠金越多，轻松降低交易成本，放大投资收益。<br />
                    <span>提醒：</span>活动7天逾期未完成要求，未提现成功，将视为自动放弃奖励权益，即该笔人民币资金会被扣回，您的其他权益不受影响。

                    如果7天内，新客完成最低层级3手的要求，作为保底，288元人民币的等额美金可以正常提取。



                </li>
                <li>

                    <table>
                        <tr>
                            <th>入金区间(美金)</th>
                            <th>现金红包(人民币)</th>
                            <th>美元现金(等额人民币)</th>
                            <th>总赠送额(人民币)</th>
                            <th>7日内提现手数(手)</th>

                        </tr>
                        <tr>
                            <th>100≤首入金&lt;300</th>
                            <th>288</th>
                            <th>0</th>
                            <th>288</th>
                            <th>3</th>
                        </tr>
                        <tr>
                            <th>300≤首入金&lt;500</th>
                            <th>288</th>
                            <th>300</th>
                            <th>588</th>
                            <th>5</th>
                        </tr>
                        <tr>
                            <th>500≤首入金&lt;1000</th>
                            <th>288</th>
                            <th>600</th>
                            <th>888</th>
                            <th>8</th>
                        </tr>
                        <tr>
                            <th>1000≤首入金</th>
                            <th>288</th>
                            <th>900</th>
                            <th>1188</th>
                            <th>12</th>
                        </tr>

                    </table>
                </li>
                <!-- <li>
                    <span>第三阶段</span><br />
                    <span>绝对独家保障！</span>7日亏损全险<br />
                    新人首入200美金以上者，即可7天内享平台补贴，有效期内累计交易亏损达到交易补贴额度，即可获得对应现金<br />

                    1.补贴获得的美元现金和美元赠金，7日后达标自动打入账户余额。<br />

                    2.得到的现金可当真实资金使用，可交易可提现，提现时无手数要求。<br />

                    3.补贴仅能获得一次，无法重复获取。
                </li>


                <li>

                    <table>
                        <tr>
                            <th>层级</th>
                            <th>7日累计亏损</th>
                            <th>补贴方案</th>

                        </tr>
                        <tr>
                            <th>L1</th>
                            <th>≥$5,000</th>
                            <th>$1，000美元现金+$4，000美元赠金</th>
                        </tr>
                        <tr>
                            <th>L2</th>
                            <th>≥$10,000</th>
                            <th>$2，000美元现金+$8,000美元赠金</th>
                        </tr>
                        
                    </table>
                </li> -->
                <li>
                    <span>备注说明</span><br />
                    现金红包/人民币红包： 以人民币形式发放，用户可前往平台——我的钱包 中查看。<br />

                    人民币红包及人民币等额的美元现金，系统统一采用固定汇率7，并取整的形式来计算，并打入交易账户。<br />

                    美元现金：以美元形式发放至交易账户，可用作交易，满足提取条件后，可提取也可交易，无特殊限制。<br />

                    美元赠金：是美元形式的赠金，不可用于交易，按照交易手数笔笔提取，前往平台——我的——赠金奖励 中查看。<br />

                    为保证客户账户资金的配置，当客户获得总赠送588及以上人民币的层级，其账户强平比例调整为50%，活动结束后恢复。
                    <br />
                </li>
                <li>
                    <span>注意事项</span><br />
                    1. 参加原新用户活动的客户，无法重复参加该活动；<br />

                    2. 同一真实交易账户不可被多次邀请参加；<br />

                    3. 交易手数的计算：本活动只针对伦敦金伦敦银交易的手数计算，开仓一手再平仓一手，如此来回为一手；<br />

                    4.
                    若判定客户交易存在异常，例如恶意套利行为、短时间内如1分钟频繁进出经平台审核后实属剥头皮交易...等，公司皆有权收回相应交易优惠，本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import ContactusVue from "@/component/base-footer";
import userSign from '@/mixins/userSign';
import { generateQRCode } from "@/utils/tools";
import { mapState, mapActions } from "vuex";

export default {
    components: {
        ContactusVue

    },
    mixins: [userSign],
    data() {
        return {

            navBarFixed: false,
            scroll: "",
            screenWidth: null,
            slider: true,
            showDialog: false,
            formattedDateString: '',
            timer: null,
            qrCodeUrl: '',
            loginDialog: false,//注册成功弹框
            account: '',//账号
            password: '',//密码
            isApp: false,//是否App进入 
            form: {
                phone: '',
                code: '',
            },
            tabbarShow: true,
            isApp: false,
            controlPop: false,
            showFloat: true,
        };
    },

    mounted() {

        const { origin } = window.location;
        const channel = sessionStorage.getItem('channel');
        console.log('下载地址-------------------', channel)
        let url = origin + '/subject/download?channel=' + channel

        generateQRCode(url, this.$refs.qrcodeCanvas)

        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        };


    },
    destroyed() {

    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                // this.$router.push({
                //     name: "sc_2024wap",
                //     query: this.$route.query || {},
                // });
            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);
        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.tabbarShow = false

            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)

        }

        else {

        }

    },
    methods: {

        getLastDayOfMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const lastDayOfMonth = new Date(year, month, 0);
            // 获取最后一天的日期
            const lastDate = lastDayOfMonth.getDate();
            return month + '月' + lastDate + '日'
        },

        showDialogs() {
            this.controlPop = true

        },
        closePop() {
            this.controlPop = false
        },



        // 点击获取焦点
        focusInput() {
            this.$refs.inputElement.focus();
        },

        // 返回上级页面
        goback() {
            window.location.href = window.location.origin;
        },
        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 90) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }
        },
        // 提交手机号验证码
        submit(form) {
            if (form.phone && form.code) {
                this.handleRegister().then((res) => {
                    console.log('注册信息------', res)
                    this.loginDialog = true

                    localStorage.setItem('token', res.Token);
                    localStorage.setItem('account', res.account);
                    this.account = res.account
                    this.password = res.password
                }).catch(() => {
                })
            } else {
                this.$message({
                    message: '请输入手机号和验证码！',
                    type: 'warning',
                });
            }
        },
        // 回到顶部
        toTop() {
            document.documentElement.scrollTop = 0;
        },
        // 跳转到登录注册
        tosCroll() {

            const targetElements = this.$refs.targetTops;
            const targetPosition = targetElements.offsetTop
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },

        // 客服链接
        live800() {
            window.open(
                this.live800UrlUc
            );
        },
        // 下载App
        downloadApp() {
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
                try {
                    window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
                } catch (error) {
                    window.open(this.$parent.iosUrl);
                }
            } else { // 安卓
                try {
                    window.android.gotoRegisterReal();
                } catch (error) {
                    window.open(this.$parent.androidUrl);
                }
            }
        },



    },
    deactivated() {
        clearInterval(this.animate)
    },
    beforeDestroy() {
        clearInterval(this.animate)
    },
    computed: {
        ...mapState("common", {
            live800UrlUc: 'live800UrlUc',
        }),
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;


    position: relative;

    .tabbar {
        width: 100%;
        padding: 0 10%;
        box-sizing: border-box;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            margin: 20px 50px;
            width: 130px;
        }

        .downloads {
            width: 167px;
            height: 50px;
            border-radius: 20px;
            background: #ff0909;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-weight: 600;
            cursor: pointer;
        }
    }

    .contens {
        background: url(/subject/anniversary/background.png) no-repeat;
        background-size: 100% 100%;

    }


    .navBarFixed {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
    }

    .banner {
        width: 100%;
        height: 598px;

        display: block;
    }



    .wapbanner {
        width: 100%;
        display: none;
    }

    #login {
        width: 25%;
        // height: 638px;
        margin: 0 auto;
        background: url(/subject/anniversary/loginbg.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 132px 0 100px;
        position: absolute;
        top: 2vw;
        right: 8%;
        transform: translate(-50%, 0);
        display: block;
        box-sizing: border-box;

        .login-flex {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 120px;
            padding-left: 20px;
        }


        .interactive {
            width: 65%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;

            input:focus {
                outline: none;
            }

            input {
                width: 80%;
                height: 50px;
                background: #fff4e5;
                border: 1px solid #fff;
                border-radius: 10px;
                font-size: 16px;
                text-indent: 25px;
                list-style: none;
                border: 1px solid #feb869;
                // color: #ffb180;
                margin-bottom: 10px;
            }

            .codeBox {
                width: 80%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 16px 0 26px 0;

                input {
                    width: 100%;
                }

                span {
                    width: 120px;
                    height: 54px;
                    line-height: 54px;
                    font-size: 16px;
                    border-radius: 10px;
                    background: linear-gradient(to bottom, #ffefcc, #ffc994);
                    width: 120px;

                    background: #ff9625;

                    text-align: center;
                    color: #fff;
                    position: absolute;
                    top: 0vw;
                    right: 0px;
                    cursor: pointer;
                }
            }

            .loginBtn {
                width: 20%;
                cursor: pointer;
                position: relative;
                top: 15px;
            }
        }


        .buttom {
            width: 240px;
            height: 54px;
            margin: 0 auto;

            img {
                width: 100%;

            }

        }

    }

    .waplogin {
        width: 100%;
        height: 500px;
        margin: 0 auto;
        background: url(/subject/anniversary/wap/loginbg.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 52% 20px 20px;
        position: absolute;
        top: 11%;
        right: 2%;
        left: 0%;
        box-sizing: border-box;

        display: none;

        .login-flex {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .interactive {
            width: 80%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            input:focus {
                outline: none;
            }

            input {
                width: 90%;
                height: 40px;
                background: #fff4e5;
                border: 1px solid #fff;
                border-radius: 10px;
                font-size: 16px;
                text-indent: 25px;
                list-style: none;
                border: 1px solid #ff9625;
                // color: #ffb180;
                margin-bottom: 10px;
            }

            .codeBox {
                width: 90%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 16px 0 26px 0;

                input {
                    width: 100%;
                }

                span {
                    width: 100px;
                    height: 44px;
                    line-height: 40px;
                    font-size: 16px;
                    border-radius: 10px;
                    background: linear-gradient(to bottom, #ffefcc, #ffc994);
                    width: 102px;

                    background: #ff9625;

                    text-align: center;
                    color: #fff;
                    position: absolute;
                    top: 0vw;
                    right: 0px;
                    cursor: pointer;
                }
            }

            .loginBtn {
                width: 20%;
                cursor: pointer;
                position: relative;
                top: 15px;
            }
        }


        .buttom {
            width: 80%;
            height: auto;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
            }

        }

    }

    .waplogins {
        position: absolute;
        top: 66%;
        right: 0%;
    }

    .logins {
        position: absolute;
        top: 9%;
    }




    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 3vh;


        display: block;


        .part {
            width: 1200px;

            margin: 0 auto;



            .part1 {
                width: 100%;
                margin: 0 auto;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                box-sizing: border-box;

                .partbox {
                    width: 100%;
                    padding-left: 35px;
                }

                .button {
                    position: absolute;
                    bottom: -32%;
                    left: 28%;
                    z-index: 10;
                    cursor: pointer;
                }

                .button1 {
                    position: absolute;
                    top: 52%;
                    left: 28%;
                    z-index: 10;
                    cursor: pointer;
                }

                .rule {
                    width: 160px;
                    height: 40px;

                    position: absolute;
                    top: 6%;
                    right: 10%;
                    z-index: 10;
                    cursor: pointer;
                }

                .part2 {
                    position: absolute;
                    width: 1200px;
                    top: 50vw;
                    left: 4%;
                    margin: 0 auto;

                    .partbox {
                        width: 85.5%;
                        padding-left: 35px;
                    }
                }

            }



            .request {
                margin-right: 20px;
            }



            .part3 {
                width: 100%;
                margin: 28vw auto 90px 0%;
                padding-bottom: 30px;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;

                .button {
                    position: absolute;
                    bottom: 12%;
                    left: 30%;
                    z-index: 10;
                    cursor: pointer;
                }

                .partbox {
                    width: 86%;

                }


            }
        }
    }

    .wapcontent {
        display: none;
        width: 100%;
        height: auto;

        margin: 0 auto;
        padding-top: 72%;
        background: url(/subject/anniversary/wap/background.png) no-repeat;
        background-size: 100% 100%;

        .part {
            // max-width: 1400px;
            width: 100%;
            box-sizing: border-box;
            margin: 0 auto;
            margin: 45vh auto 0;
            // padding: 0 20px;


            .part1 {
                width: 100%;
                margin: 0 auto;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                }

                .rule {
                    width: 100px;
                    height: 40px;

                    position: absolute;
                    top: 7%;
                    right: 38%;
                    z-index: 10;
                    cursor: pointer;
                }


                .part2 {
                    position: absolute;
                    width: 94%;
                    margin: 0 auto;
                    top: 78%;
                    left: 4%;

                    img {
                        width: 100%;
                        height: 100%;
                    }

                }

                .button {
                    position: absolute;
                    top: 60%;
                    left: 20%;
                    z-index: 10;
                    width: 60%;
                    height: auto;
                }

                .button1 {
                    position: absolute;
                    bottom: -11%;
                    left: 20%;
                    z-index: 10;
                    width: 60%;
                    height: auto;
                }

            }

            .part3 {
                width: 100%;
                margin: 0 auto;
                margin-top: 220px;

                margin-bottom: 90px;

                padding-bottom: 60px;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                }

                .button {
                    position: absolute;
                    bottom: 16%;
                    left: 20%;
                    z-index: 10;
                    width: 60%;
                    height: auto;

                }
            }
        }
    }

    .closer {
        width: 25px;
        height: auto;
        position: fixed;
        top: 0%;
        right: 0;
        cursor: pointer;

        z-index: 9999;
    }



    .dark {
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.5;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 101;
    }



    .popup {
        overflow-x: hidden;
        width: 1100px;
        height: 900px;
        border-radius: 20px;
        background: #fdf5e6;
        position: fixed;
        top: 57%;
        left: 50%;
        transform: translate(-50%; -50%);
        box-sizing: border-box;
        padding: 10px;
        box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);
        overflow-y: scroll;
        padding-bottom: 40px;
        z-index: 99999999999999;

        .closer1 {
            float: right;
            cursor: pointer;
            margin-top: 8px;
            margin-right: 10px;
        }

        .popContent {
            box-sizing: border-box;
            padding: 40px 50px 20px;

            .top-tit {
                font-weight: 600;
                color: #000;
                font-size: 30px;
                margin-bottom: 30px;
            }

            li {
                font-size: 18px;
                color: #a86e4f;
                line-height: 36px;

                span {
                    font-weight: 600;
                    color: #e34a3f;
                }

                img {
                    width: 100%;
                    height: auto;
                    margin: 20px 0;
                }

                table {
                    border: 1px solid #e34a3f;
                    border-radius: 15px;
                    width: 100%;

                    tr {
                        th {
                            text-align: center;
                            font-weight: 500;
                            line-height: 50px;
                            border-bottom: 1px solid #d2a765;
                            border-right: 1px solid #d2a765;
                            padding: 5px;
                        }

                        th:last-child {
                            border-right: 1px solid transparent;
                        }
                    }

                    tr:nth-child(1) {
                        th {
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
}


@media screen and (max-width: 500px) {
    .box {
        .tabbar {
            width: 100%;
            padding: 0 5%;
            box-sizing: border-box;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
                margin: 20px 0px;
                width: 100px;
            }

            .downloads {
                width: 83px;
                height: 30px;
                border-radius: 20px;
                background: #ff0909;
                text-align: center;
                line-height: 30px;
                color: #fff;
                font-weight: 600;
                cursor: pointer;
                font-size: 12px;
            }
        }

        .banner {
            display: none;
        }

        .wapbanner {
            display: block;
        }

        .content {
            display: none;
        }

        .wapcontent {
            display: block;
        }

        #login {
            display: none;
        }

        .waplogin {
            display: block;
        }

        .waplogin1 {
            position: absolute;
            top: 12%;
        }






        .popup {
            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 95%;
            height: 480px;
            box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
            background-color: #fdf5e6;
            border-radius: 15px;
            overflow-y: scroll;
            z-index: 99999999;

            .closer1 {
                width: 16px;
                height: 30px;
                height: auto;
                position: absolute;
                top: 5px;
                right: 5px;
                font-size: 20px;
            }

            .popContent {
                box-sizing: border-box;
                padding: 10px;
                overflow: hidden;

                .top-tit {
                    font-size: 16px;
                    margin-top: 20px;

                }

                li {
                    font-size: 14px;
                    color: #a86e4f;
                    line-height: 24px;

                    span {
                        font-weight: 600;
                        color: #e34a3f;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }

                    table {
                        width: 100%;
                        border: 1px solid #e34a3f;
                        border-radius: 10px;

                        tr {
                            th {
                                text-align: center;
                                font-weight: 500;
                                line-height: 24px;
                                border-bottom: 1px solid #d2a765;
                                border-right: 1px solid #d2a765;
                                padding: 5px;
                            }

                            th:last-child {
                                border-right: 1px solid transparent;
                            }
                        }

                        tr:nth-child(1) {
                            th {
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }





    }
}

@media screen and (max-width: 375px) {
    .box {

        .waplogin {
            position: absolute;
            top: 10%;
            padding: 58% 20px 20px;

        }

        .logins {
            position: absolute;
            top: 8%;
        }

        .wapcontent {
            .part {
                margin-top: 60vh;
            }
        }
    }

}

@media screen and (max-width: 390px) {
    .box {

        .wapcontent {
            .part {
                margin-top: 50vh !important;
            }
        }
    }

}

@media screen and (max-width: 414px) {
    .box {

        .wapcontent {
            .part {
                margin-top: 56vh;
            }
        }
    }

}


//--------------------------110----------------------
@media screen and (min-width: 1724px) and (max-width: 1897px) {
    .box {
        #login {
            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }
        }

        .content {
            .part {



                .part1 {


                    .button1 {
                        position: absolute;

                        left: 25%;
                        width: 40%
                    }

                    .button {
                        position: absolute;
                        bottom: -32%;
                        left: 28%;
                        width: 40%
                    }

                    .rule {
                        // background: #e34a3f;
                        position: absolute;
                        right: 24%;
                    }

                    .part2 {
                        position: absolute;
                        top: 55vw;
                    }
                }

                .part3 {
                    margin-top: 32vw;

                    .button {
                        width: 30%;
                        position: absolute;
                        left: 32%;
                    }
                }

            }
        }





        .popup {
            height: 800px;
        }


    }

}

// ---------------125%------------------
@media screen and (min-width: 1517px) and (max-width: 1724px) {
    .box {
        #login {
            height: 30vw;

            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }

            .login-flex {
                padding-top: 60px;
            }

            .interactive {
                padding-top: 2%;

                input {
                    height: 40px;
                    font-size: 14px;
                }

                .codeBox {
                    margin-bottom: 10px;

                    span {
                        width: 82px;
                        font-size: 12px;
                        height: 42px;
                        line-height: 42px;
                        font-size: 14px;
                    }
                }
            }
        }

        .content {
            .part {



                .part1 {
                    .button1 {
                        width: 40%;
                        position: absolute;
                        left: 25%;
                    }

                    .button {
                        position: absolute;
                        bottom: -31%;
                        left: 28%;
                        width: 40%
                    }

                    .part2 {
                        position: absolute;
                        top: 62vw;
                    }
                }

                .part3 {
                    margin-top: 32vw;

                    .button {
                        width: 30%;
                        position: absolute;
                        left: 32%;
                    }
                }


            }
        }






    }
}

// -------------------150%--------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {
    .box {
        #login {
            height: 30vw;

            .login-flex {
                padding-top: 0;
            }

            .buttom {
                width: 180px;
            }

            .interactive {
                padding-top: 10%;

                input {
                    height: 40px;
                    font-size: 10px;
                }

                .codeBox {
                    margin-bottom: 10px;

                    span {
                        width: 62px;
                        font-size: 12px;
                        height: 42px;
                        line-height: 42px;
                        font-size: 10px;
                    }
                }
            }
        }

        .content {
            .part {



                .part1 {


                    .button1 {

                        width: 40%;
                        position: absolute;

                        left: 30%;


                    }

                    .button {
                        position: absolute;
                        bottom: -30%;

                        width: 40%
                    }

                    .part2 {
                        width: 1184px;
                        position: absolute;
                        top: 74vw;
                    }
                }



                .part3 {
                    margin-top: 38vw;

                    .button {
                        position: absolute;

                        left: 35%;
                        width: 30%
                    }
                }

            }
        }

        .popup {
            height: 600px;
        }

    }
}
</style>